import axios from 'axios';

export default {
	pre_insertar(p_email, p_usuario, p_acvcodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_condvta.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_acvcodigo": p_acvcodigo
				  })
			})
	},

	insertar(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_condvta.insertar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_acvcodigo": datosFormulario.acvcodigo,
					"p_acvtipo": datosFormulario.acvtipo,
					"p_acvdescrip": datosFormulario.acvdescrip
				  })
			})
	},

	buscar(p_email, p_usuario, p_acvcodigo, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_condvta.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_acvcodigo": p_acvcodigo,
					"p_tiporec": p_tiporec
				  })
			})
	},

	modificar(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_condvta.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_acvcodigo": datosFormulario.acvcodigo,
					"p_acvtipo": datosFormulario.acvtipo,
					"p_acvdescrip": datosFormulario.acvdescrip,
					"p_acvestado": datosFormulario.acvestado
				  })
			})
	},

	eliminar(p_email, p_usuario, p_acvcodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_condvta.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_acvcodigo": p_acvcodigo
				  })
			})
	},

	activar(p_email, p_usuario, p_acvcodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_anapp_condvta.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_acvcodigo": p_acvcodigo
				  })
			})
	}
}